export default [
  {
    title: 'Pencairan',
    komicon: 'k-receive-square',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'WD Partner',
        tagVariant: 'light-warning',
        komicon: 'k-user-tick',
        route: 'cod-pencairan',
        resource: 'Pencairan - WD Partner',
        action: 'manage',
      },
      {
        title: 'WD Mitra',
        tagVariant: 'light-warning',
        komicon: 'k-profile-2user',
        route: 'withdrawal-mitra',
        resource: 'Pencairan - WD Mitra',
        action: 'manage',
      },
      {
        title: 'WD Affiliate',
        tagVariant: 'light-warning',
        komicon: 'k-people',
        route: 'withdrawal-affiliate',
        resource: 'Pencairan - WD Affiliate',
        action: 'manage',
      },
      {
        title: 'WD Collaboration',
        tagVariant: 'light-warning',
        komicon: 'k-hashtag-1',
        route: 'withdrawal-collaborator',
        resource: 'Pencairan - WD Collaboration',
        action: 'manage',
      },
      {
        title: 'Monitoring Saldo Minus',
        tagVariant: 'light-warning',
        komicon: 'k-monitor',
        route: 'monitoring-saldo-minus',
        resource: 'Pencairan - Monitoring Saldo Minus',
        action: 'manage',
      },
      {
        title: 'Mutasi Bank',
        tagVariant: 'light-warning',
        komicon: 'k-card',
        route: 'mutation-bank',
        resource: 'Pencairan - Mutasi Bank',
        action: 'manage',
      },
    ],
  },
]
